import React from "react";
import $ from "jquery";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-buttons-dt/css/buttons.dataTables.min.css";

// import jsZip from 'jszip';
import "datatables.net-buttons/js/buttons.flash.min";
import "datatables.net-buttons/js/buttons.html5.min";
import "datatables.net-buttons/js/buttons.print.min";

import { toast } from "react-toastify";

import "./DataTable.css";

require("datatables.net");
require("datatables.net-buttons");

// window.JSZip = jsZip;

const defaultTableID = "uangelDataTable";
export default class DataTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: "",
      tableID: this.props.tableID ? this.props.tableID : defaultTableID,
      filterValues: {},
    };
    this.datatable = null;
  }

  componentDidMount() {
    this.refreshDataTable(true);
    // $('#keezleDataTable tbody').on('click', 'tr', (e) => {
    //     if ($(e.currentTarget).hasClass('selected')) {
    //         $(e.currentTarget).removeClass('selected');
    //     } else {
    //         this.dataTable.$('tr.selected').removeClass('selected');
    //         $(e.currentTarget).addClass('selected');
    //         // TODO: 선택시 이벤트 처리 함수 추가
    //         // console.debug('data-table tr click=========');
    //         // console.debug(this.dataTable.row(this).data());
    //         // console.debug(this.dataTable.$('tr.selected').data());
    //     }
    //     // if (onSelect) {
    //     //     onSelect(this.dataTable.row(this).data());
    //     // }
    // });
    // $(`#tblSetting_filter label input`).keyup((e) => {
    //     console.debug('================ key up');
    //     console.debug(e);
    // });
  }

  componentDidUpdate() {}

  componentWillUnmount() {
    if (this.dataTable) {
      this.dataTable.destroy(true);
    }
  }

  refreshDataTable = (isNew = false) => {
    const { ajaxOpt, filters, ...options } = this.props;
    const { onDataReceived, onDraw } = this.props;
    const { onClick } = this.props;
    const { tableID, filterValues } = this.state;

    if (isNew && this.dataTable) {
      this.dataTable.clear().destroy();
      $(`#${tableID} thead`).empty();
      $(`#${tableID} tbody`).empty();
      $(`#${tableID} tfoot`).empty();
    }

    let ajaxOptFull = null;
    if (ajaxOpt) {
      const authToken = localStorage.getItem("auth_token");
      const userType = localStorage.getItem("login_user_type");
      const userIndex = localStorage.getItem("login_user_index");
      ajaxOptFull = {
        url: `${process.env.REACT_APP_API_URL}${ajaxOpt.url}`,
        type: "POST",
        headers: {userType, userIndex, authToken},
        data: (d) => {
            var filterData = [];
            if (filters && filterValues) {
              filters.forEach((f, idx) => {
                if (filterValues[f.data]) {
                  filterData.push(filterValues[f.data]);
                }
              });
            }
          return $.extend(d, {filter: filterData});
        },
        dataFilter: (response) => {
          const json = JSON.parse(response);
          if (onDataReceived) {
            json.data = onDataReceived(json.data);
          } else {
            return JSON.stringify(json.data);
          }
        },
        error: (jqXHR, ajaxOptions, thrownError) => {
          const json = JSON.parse(jqXHR.responseText);
          console.error(json);
        },
      };
    }

    this.$el = $(this.el);
    this.dataTable = this.$el.DataTable({
      ...options,
      ...options.options,
      language: {
        emptyTable: "데이터가 없습니다.",
        zeroRecords: "데이터가 없습니다.",
        info: "전체 _TOTAL_ / _START_ ~ _END_",
        infoEmpty: "전체 0 / 0 ~ 0",
        lengthMenu: "페이지당 _MENU_ 개씩 표시",
        paginate: {
          first: "처음",
          last: "마지막",
          next: "다음",
          previous: "이전",
        },
      },
      ajax: ajaxOptFull,
      select: {
        style: "single",
      },
      fnDrawCallback: () => {
        const rows = this.getData();
        if (onDraw) {
          onDraw(rows);
        }
      },
    });

    $.fn.dataTable.ext.errMode = (settings, helpPage, message) => {
      console.error(message);
    };
    this.dataTable.on("draw", () => {
      // console.debug('data-table draw=========');
    });
  };

  table = () => {
    return this.dataTable;
  };

  loadData = (newUrl) => {
    this.dataTable.ajax.url(`${process.env.REACT_APP_API_URL}${newUrl}`).load();
  };

  reloadData = () => {
    this.dataTable.ajax.reload();
  };

  redraw = () => {
    this.dataTable.draw();
  };

  onChangeSearch = (e) => {
    const { value } = e.target;
    const { searchValue } = this.state;
    const searchValueNew = value;

    this.setState({ searchValue: searchValueNew });
    if (searchValueNew === "" && searchValue !== "") {
      this.search(searchValueNew);
    }
  };

  onChangeFilter = (e) => {
    const { name, value } = e.target;
    const { filterValues } = this.state;
    filterValues[name] = value;
    this.setState({filterValues}, () => {
        const { searchValue } = this.state;
        this.search(searchValue);
    });
  };

  handleKeyPress = (e) => {
    if (e.key === "Enter") {
      const { searchValue } = this.state;
      this.search(searchValue);
    }
  };

  // connecting search to an external component, optional but shows how to access the API
  search = (value) => {
    if (this.dataTable) {
      const { tableID } = this.state;
      this.dataTable.search(value).draw();
      $(`#${tableID} thead`).empty();
      $(`#${tableID} tbody`).empty();
      $(`#${tableID} tfoot`).empty();
    }
  };

  getData = (valOrField, val) => {
    if (this.dataTable) {
      if (valOrField) {
        const data = this.dataTable.data();
        if (data && data.length > 0) {
          let field = valOrField;
          let value = val;
          if (!val) {
            value = valOrField;
            field = "id";
          }
          for (let i = 0; i < data.length; i += 1) {
            if (data[i][field] === value) {
              return data[i];
            }
          }
        }
        return null;
      }
      return this.dataTable.data();
    }
    return null;
  };

  // get datatables.net-button with button class name
  // excel button call - .buttons-excel
  button = (btnClass) => {
    return this.dataTable.buttons(btnClass);
  };

  render() {
    const {
      searching,
      searchHolder,
      searchingFieldVisible,
      filters,
      tableClass,
      children,
    } = this.props;
    const { searchValue, tableID, filterValues } = this.state;

    return (
      <div>
        <div className="row mb-0 pb-0">
          {filters && (
            <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
              <div className="row justify-content-end dataTablesFilters">
                {filters.map((f, fIdx) => {
                  const options = f.options;
                  return (
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">
                      <div className="input-group input-group-sm">
                        <div className="input-group-prepend">
                          <label
                            className="input-group-text"
                            htmlFor="inputGroupSelect01"
                          >
                            {f.title}
                          </label>
                        </div>
                        <select
                          className="form-control"
                          name={f.data}
                          value={filterValues[f.data]}
                          onChange={this.onChangeFilter}
                        >
                          {options.map((o, oIdx) => {
                            return (
                              <option key={`${f.data}-${oIdx}`} value={o.value}>
                                {o.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {searching && searchingFieldVisible ? (
            <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
              <input
                className="form-control form-control-sm dataTablesSearch"
                value={searchValue}
                onChange={this.onChangeSearch}
                autoComplete="off"
                type="ext"
                style={{ zIndex: "1" }}
                placeholder={searchHolder}
                onKeyPress={this.handleKeyPress}
              />
            </div>
          ) : (
            <></>
          )}
        </div>
        <div className="row">
          <div className="col-12">
            <table
              id={tableID}
              className={
                !tableClass ? "display compact cell-border" : tableClass
              }
              style={{ width: "100%" }}
              ref={(el) => {
                this.el = el;
              }}
            >
              {children}
            </table>
          </div>
        </div>
      </div>
    );
  }
}
